import { render, staticRenderFns } from "./LandChip.vue?vue&type=template&id=3946407b&"
import script from "./LandChip.vue?vue&type=script&lang=js&"
export * from "./LandChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports